function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0837 4.58328H5.50033C5.0141 4.58328 4.54778 4.77643 4.20396 5.12025C3.86015 5.46407 3.66699 5.93038 3.66699 6.41661V16.4999C3.66699 16.9862 3.86015 17.4525 4.20396 17.7963C4.54778 18.1401 5.0141 18.3333 5.50033 18.3333H15.5837C16.0699 18.3333 16.5362 18.1401 16.88 17.7963C17.2238 17.4525 17.417 16.9862 17.417 16.4999V11.9166M16.1208 3.28711C16.2899 3.11201 16.4922 2.97234 16.7159 2.87626C16.9396 2.78018 17.1802 2.7296 17.4236 2.72749C17.667 2.72537 17.9084 2.77176 18.1337 2.86394C18.3591 2.95612 18.5637 3.09225 18.7359 3.26439C18.908 3.43652 19.0441 3.64122 19.1363 3.86653C19.2285 4.09184 19.2749 4.33325 19.2728 4.57668C19.2707 4.82011 19.2201 5.06068 19.124 5.28435C19.0279 5.50803 18.8883 5.71033 18.7132 5.87945L10.8427 13.7499H8.25033V11.1576L16.1208 3.28711Z",
  stroke: "#1F003F",
  strokeWidth: 2.03,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgNewChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChat);
export default __webpack_public_path__ + "static/media/NewChat.8ee274541f1c61769843b9d2192db0d6.svg";
export { ForwardRef as ReactComponent };